<template>
  <section class="content-plans-register">
    <Breadcrumb :links="links" :data="this.dataProps" />
    <form class="content-plans-register-form" @submit.prevent="handleSubmit()">
      <div class="row">
        <div class="col-12">
          <div class="content-input-default">
            <input
              type="text"
              name="name"
              v-model="company.name"
              value=""
              placeholder="Nome*"
              required
            />
          </div>
        </div>
        <div class="col-12">
          <div class="content-input-default">
            <input
              type="text"
              name="cnpj"
              v-model="company.cnpj"
              v-mask="['##.###.###/####-##']"
              value=""
              placeholder="CNPJ*"
              required
            />
            <span>Somente números</span>
          </div>
        </div>
        <div class="col-12">
          <div class="content-input-default">
            <input
              type="text"
              name="answerable"
              v-model="company.answerable"
              value=""
              placeholder="Nome do responsável pela empresa*"
              required
            />
          </div>
        </div>
        <div class="col-12">
          <div class="content-input-default">
            <input
              type="email"
              name="email"
              v-model="company.email"
              value=""
              placeholder="E-mail da empresa*"
              required
            />
          </div>
        </div>
        <div class="col-12">
          <div class="content-input-default">
            <input
              type="text"
              name="number_whats_app"
              v-model="company.number_whats_app"
              value=""
              placeholder="Número do Whatsapp da empresa*"
              required
            />
          </div>
        </div>
        <div class="col-12">
          <div class="content-input-default">
            <input
              type="text"
              name="number_of_collaborators"
              v-model="company.number_of_collaborators"
              v-mask="'#####'"
              value=""
              placeholder="Número de colaboradores da empresa*"
              required
              :disabled="isDisabledHasPlanActive"
            />
            <span v-if="isDisabledHasPlanActive" class="disabled-text">
              Não é possível mudar o número de colaboradores, porque essa
              empresa tem plano ativo.
            </span>
            <span v-else>Somente números. Ex: 100 </span>
          </div>
        </div>
        <div class="col-12">
          <button class="btn-green">Salvar</button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      links: [
        {
          name: "Empresas",
          routerName: "Company",
        },
        {
          name: "Registrar Empresa",
          routerName: "RegisterCompany",
        },
      ],
      company: {
        name: "",
        cnpj: "",
        answerable: "",
        email: "",
        number_of_collaborators: "",
        number_whats_app: "",
      },
      companyParams: this.$route.params,
      dataProps: { module: "Company" },
    };
  },
  computed: {
    ...mapGetters({
      user: "User/user",
      companiesData: "Company/companies",
      hasPlanActive: "Company/hasPlanActive",
    }),
    hasCompanyParams() {
      return this.companyParams && Object.keys(this.companyParams).length > 0;
    },
    isDisabledHasPlanActive() {
      if (
        !this.hasCompanyParams ||
        !this.hasPlanActive ||
        Object.keys(this.hasPlanActive).length === 0
      ) {
        return false;
      }

      return !!this.hasPlanActive;
    },
  },
  components: {
    Breadcrumb,
  },
  methods: {
    ...mapActions("Company", ["registerCompany", "consultCompanies"]),
    async handleSubmit() {
      let message = this.company?.id
        ? "Empresa editado com sucesso!"
        : "Empresa cadastrado com sucesso!";

      await this.registerCompany(this.company);
      this.$router.push({ name: "ListCompanies" });
      this.$swal.fire({
        icon: "success",
        html: message,
      });
    },
  },
  async mounted() {
    if (this.hasCompanyParams) {
      await this.consultCompanies(this.companyParams);
      this.dataProps = {
        name: this.companiesData.name,
        id: this.companyParams.id,
        module: "Company",
        type: "Company",
      };
      this.company = this.companiesData;
      this.links = [
        {
          name: "Empresas",
          routerName: "Company",
        },
        {
          name: "Listar Empresas",
          routerName: "ListCompanies",
        },
        {
          name: `Menu - ${this.$route.params.slug}`,
          routerName: "MenuCompany",
          routerParams: {
            params: {
              ...this.$route.params,
            },
          },
        },
        {
          name: "Editar",
          routerName: "EditCompany",
        },
      ];
    }
  },
};
</script>

<style lang="scss" scoped>
.content-plans-register {
  padding-bottom: 50px;
  h2 {
    font-size: 24px;
    font-family: "Font Semibold";
    color: var(--black);
    text-align: left;
    margin-bottom: 30px;
  }

  .plans-company {
    position: relative;
    padding: 30px 0;
    margin: 30px 0;
    border-top: 1px solid var(--gray-light);

    .content-switch {
      position: absolute;
      top: 30px;
      right: 0;
      display: flex;
      align-items: center;
      margin-right: 15px;
      margin-bottom: 10px;
      @media (max-width: 991px) {
        margin-bottom: 0;
      }
      &--text {
        font-size: 12px;
        font-family: "Font Light";
        color: var(--black);
        margin-right: 10px;
        margin-bottom: 0;
      }
      .switch {
        position: relative;
        display: inline-block;
        width: 51px;
        height: 26px;
        margin-bottom: 0;
      }
      /* Hide default HTML checkbox */
      .switch input {
        opacity: 0;
        width: 0;
        height: 0;
      }
      /* The slider */
      .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: var(--red-dark);
        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
        -webkit-transition: 0.4s;
        transition: 0.4s;
      }
      .slider:before {
        position: absolute;
        content: "";
        height: 20px;
        width: 20px;
        left: 3px;
        bottom: 3px;
        background-color: var(--white);
        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
        -webkit-transition: 0.4s;
        transition: 0.4s;
      }
      input:checked + .slider {
        background-color: var(--green);
      }
      input:checked + .slider:before {
        -webkit-transform: translateX(25px);
        -ms-transform: translateX(25px);
        transform: translateX(25px);
      }
      /* Rounded sliders */
      .slider.round {
        border-radius: 20px;
      }
      .slider.round:before {
        border-radius: 100%;
      }
    }
  }
}
.content-input-default {
  textarea {
    min-height: 250px;
  }
}
.btn-green {
  margin-top: 100px;
  @media (max-width: 991px) {
    margin-top: 50px;
  }
}
</style>
